import * as React from "react";
const SvgFiRrSortAlphaDownAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M15 1a1 1 0 0 1 1-1h4.112a1.888 1.888 0 0 1 1.598 2.887 1 1 0 0 1-.103.136l-4.449 4.978H21a1 1 0 1 1 0 2h-4.112a1.886 1.886 0 0 1-1.599-2.886c.03-.049 4.553-5.114 4.553-5.114h-3.84a1 1 0 0 1-1-1zm7 16.5V23a1 1 0 1 1-2 0v-2h-3v2a1 1 0 1 1-2 0v-5.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5M20 19v-1.5c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5V19zm-9.707-1.293L7 21V1a1 1 0 1 0-2 0v20l-3.293-3.293a.999.999 0 1 0-1.414 1.414l4.293 4.293c.39.39.902.585 1.414.585s1.024-.195 1.414-.585l4.293-4.293a.999.999 0 1 0-1.414-1.414"
    />
  </svg>
);
export default SvgFiRrSortAlphaDownAlt;
